import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPairList } from '../../../features/ats/atsSlice';
import CardHeading from "../../../components/common/CardHeading/CardHeading.jsx";
import "./WatchList.scss";
import { Nav, Tab } from 'react-bootstrap';
import { StarIcon } from "../../../assets/Svg/SvgImages.jsx";
import FavouriteTable from "./FavouriteTable/FavouriteTable.jsx";
import CommonSearch from "../../../components/ui/CommonSearch/CommonSearch.jsx";
import { parseJSON } from '../../../helpers/commonHelper';
const WatchList = ({
  sectionRef
}) => {
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const [pairs, setPairs] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const pairList = useSelector(state => state?.ats?.pairList);
  const lastPrice = useSelector(state => state?.ats?.lastPrice);
  const selectedPair = useSelector(state => state?.ats?.selectedPair);
  const favPairList = useSelector(state => state?.persist?.favPairList);
  const setWatchListRootRef = useCallback(node => {
    rootRef.current = node;
    if (typeof sectionRef === 'function') {
      sectionRef(node);
    } else if (sectionRef) {
      sectionRef.current = node;
    }
  }, [sectionRef]);
  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active = document.fullscreenElement === el || document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
    };
    document.addEventListener('fullscreenchange', syncFullscreen);
    document.addEventListener('webkitfullscreenchange', syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener('fullscreenchange', syncFullscreen);
      document.removeEventListener('webkitfullscreenchange', syncFullscreen);
    };
  }, []);
  useEffect(() => {
    if (pairList && pairList.length) {
      setPairs(parseJSON(pairList));
    }
  }, [pairList]);
  useEffect(() => {
    if (pairList.length) {
      const pair = parseJSON(pairList);
      pair.forEach(ele => {
        const index = favPairList.findIndex(o => o.id === ele.id);
        ele.isFav = index > -1 ? true : false;
      });
      const index = pair.findIndex(o => o.pair_key.toLowerCase() === selectedPair.pair_key.toLowerCase());
      if (index > -1) pair[index].last_price = lastPrice;
      dispatch(setPairList(parseJSON(pair)));
    }
  }, [lastPrice]);
  const onPairChange = e => {
    const {
      value
    } = e.target;
    const filteredList = pairList.filter(o => o.pair_key.includes(value.toLowerCase()));
    setPairs(parseJSON(filteredList));
  };
  return <div className={`watchList${isFullscreen ? ' is-fullscreen' : ''}`} ref={setWatchListRootRef}>
      <div className='watchList__panel'>
        <div className='watchList__header'>
          <CardHeading title="Watch List" />
          <CommonSearch placeholder="Search" onChange={onPairChange} maxLength={20} />
        </div>
        <div className='watchList__tabsRoot'>
          <Tab.Container id="left-tabs-example" defaultActiveKey="crypto">
            <Nav variant="pills" className="borderTabs">
              <Nav.Item>
                <Nav.Link eventKey="favourites"><StarIcon /> Favorites</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="crypto">Asset</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="favourites">
                <FavouriteTable pairList={favPairList} />
              </Tab.Pane>
              <Tab.Pane eventKey="crypto">
                <FavouriteTable pairList={pairs} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>;
};
export default WatchList;